import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../../environments/environment';
import { EmployeeAccessBuilder } from '../../models/builders/employee-access.builder';
import { EmployeeBuilder } from '../../models/builders/employee.builder';
import { Employee } from '../../models/employee';
import { EmployeeAccess } from '../../models/employee-access';
import { HttpService } from '../base/http.service';

const createEmployeeRequest = (employee: Employee): any => {
  return {
    firstname: employee.firstname,
    lastname: employee.lastname,
    birthDate: employee.birthDate,
    email: employee.email,
    password: employee.password,
    admin: employee.admin,
    salary: (employee.salary) ? employee.salary : null
  };
};

const editEmployeeRequest = (employee: Employee): any => {
  return {
    firstname: employee.firstname,
    lastname: employee.lastname,
    birthDate: employee.birthDate,
    email: employee.email,
    admin: employee.admin,
    salary: (employee.salary) ? employee.salary : null
  };
};

const employeeAccessRequest = (employeeAccess: EmployeeAccess) => {
  return {
    codePinAccess: employeeAccess.codePinAccess,
    emailPassAccess: employeeAccess.emailPassAccess,
    nfcAccess: employeeAccess.nfcAccess,
    code: employeeAccess.code,
    pin: employeeAccess.pin
  };
};

@Injectable()
export class EmployeeHttpService {
  private apiUrl: string;

  constructor(private httpService: HttpService) {
    this.apiUrl = `${environment.apiUrl}users/employees`;
  }

  changeEmployeePassword(hash: string, password: string, passwordRepeat: string) {
    const putBody = { password, passwordRepeat };
    return this.httpService.put(`${this.apiUrl}/${hash}/password`, putBody);
  }

  createEmployee(employee: Employee): Observable<string> {
    const postBody = createEmployeeRequest(employee);

    return this.httpService.post(this.apiUrl, postBody)
      .map((response: Response) => response.json())
      .pluck('hash');
  }

  deleteEmployee(hash: string): Observable<Response> {
    return this.httpService.delete(`${this.apiUrl}/${hash}`);
  }

  editEmployee(employee: Employee): Observable<Response> {
    const putBody = editEmployeeRequest(employee);

    return this.httpService.put(`${this.apiUrl}/${employee.hash}`, putBody);
  }

  editEmployeeAccess(hash: string, employeeAccess: EmployeeAccess) {
    const putBody = employeeAccessRequest(employeeAccess);

    return this.httpService.put(`${this.apiUrl}/${hash}/access`, putBody);
  }

  getEmployee(hash: string): Observable<Employee> {
    return this.httpService.get(`${this.apiUrl}/${hash}`)
      .map((response: Response) => response.json())
      .map(EmployeeBuilder.fromJson);
  }

  getEmployeeAccess(hash: string): Observable<EmployeeAccess> {
    return this.httpService.get(`${this.apiUrl}/${hash}/access`)
      .map((response: Response) => response.json())
      .map(EmployeeAccessBuilder.fromJson);
  }

  getEmployees(): Observable<Employee[]> {
    return this.httpService.get(this.apiUrl)
      .map((response: Response) => response.json())
      .map(EmployeeBuilder.fromJsonList);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/api/employee-http.service.ts